var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareTransitionsAndHospitalCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 72,
    viewBox: "0 0 103 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8374_34257)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8374_34257)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8374_34257",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.372 5.34058C55.4722 6.89784 49.2757 6.43922 43.2138 5.67941C41.3507 5.44668 39.4979 5.18314 37.6728 4.94698C27.8778 3.66352 16.7959 3.30073 9.38837 9.78649C7.12162 11.7716 5.37238 14.2837 3.99232 16.9499C0.090187 24.483 -0.917259 33.4467 1.21149 41.6471C8.67074 70.3625 50.4349 75.4518 74.7793 68.658C77.8741 67.7955 80.9275 66.7311 83.7807 65.256C84.2362 65.0198 84.6881 64.7734 85.1298 64.5167C95.3215 58.5888 101.797 47.0069 102.005 35.3428C102.212 23.6581 99.9862 10.7893 89.5391 3.70117C86.2028 1.43885 82.9976 0.614014 79.8269 0.614014C73.7511 0.614014 67.8134 3.63614 61.372 5.34058Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8374_34257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.249 -17.3887H-12.8613V85.278H120.249V-17.3887Z",
    fill: "#73D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.249 48.9235H-12.8613V85.2779H120.249V48.9235Z",
    fill: "#0E9D97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7475 53.52H16.7031V15.6493C16.7031 14.7355 17.4484 13.9962 18.3696 13.9962H72.7475V53.5166V53.52Z",
    fill: "#F4F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5271 42.0271H40.9648V53.5201H47.5271V42.0271Z",
    fill: "#47C2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.489 42.0271H47.9268V53.5201H54.489V42.0271Z",
    fill: "#47C2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8839 17.7508H24.352V16.2312C24.352 16.0361 24.1933 15.8752 23.9932 15.8752H22.2612C22.0646 15.8752 21.9024 16.0327 21.9024 16.2312V17.7508H20.3705C20.1739 17.7508 20.0117 17.9082 20.0117 18.1068V19.8249C20.0117 20.02 20.1704 20.1808 20.3705 20.1808H21.9024V21.7004C21.9024 21.8955 22.0611 22.0564 22.2612 22.0564H23.9932C24.1899 22.0564 24.352 21.899 24.352 21.7004V20.1808H25.8839C26.0806 20.1808 26.2427 20.0234 26.2427 19.8249V18.1068C26.2427 17.9117 26.084 17.7508 25.8839 17.7508Z",
    fill: "#10BEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.52 33.6624H19.415V38.4231H28.52V33.6624Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5308 33.6624H38.4258V38.4231H47.5308V33.6624Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5376 33.6624H57.4326V38.4231H66.5376V33.6624Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.52 25.301H19.415V30.0618H28.52V25.301Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5308 25.301H38.4258V30.0618H47.5308V25.301Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5376 25.301H57.4326V30.0618H66.5376V25.301Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5308 16.9363H38.4258V21.6971H47.5308V16.9363Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5376 16.9363H57.4326V21.6971H66.5376V16.9363Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0249 33.6624H28.9199V38.4231H38.0249V33.6624Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0249 25.301H28.9199V30.0618H38.0249V25.301Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0249 16.9363H28.9199V21.6971H38.0249V16.9363Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0317 33.6624H47.9268V38.4231H57.0317V33.6624Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0317 25.301H47.9268V30.0618H57.0317V25.301Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0317 16.9363H47.9268V21.6971H57.0317V16.9363Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.52 42.0271H19.415V46.7879H28.52V42.0271Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0249 42.0271H28.9199V46.7879H38.0249V42.0271Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5376 42.0271H57.4326V46.7879H66.5376V42.0271Z",
    fill: "#1B566B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0425 33.6624H66.9375V38.4231H76.0425V33.6624Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0425 25.301H66.9375V30.0618H76.0425V25.301Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0425 16.9363H66.9375V21.6971H76.0425V16.9363Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0425 42.0271H66.9375V46.7879H76.0425V42.0271Z",
    fill: "#0383A4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8374_34257",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 0,
    width: 49,
    height: 62
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8763 4.91618L42.4893 61.433H89.5184C89.8117 61.1866 90.1015 60.9367 90.3879 60.68V4.30012C90.1118 4.09476 89.8289 3.89625 89.5426 3.70117C86.2063 1.43885 82.9976 0.614014 79.8304 0.614014C74.2307 0.614014 68.7484 3.18094 62.8797 4.91618",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8374_34257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.2274 53.52H24.1797V30.0583L36.1897 13.9996H74.2174L86.2274 30.0583V53.52Z",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2764 30.0583L36.2864 13.9996H74.3141L86.3241 30.0583H24.2764Z",
    fill: "#774331"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9594 10.2588H69.998V21.7518H74.9594V10.2588Z",
    fill: "#F15961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9305 36.0444H50.4736V53.5235H59.9305V36.0444Z",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1114 35.6473H64.7637V40.7949H70.1114V35.6473Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1114 41.5856H64.7637V46.7331H70.1114V41.5856Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2218 35.6473H70.874V40.7949H76.2218V35.6473Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2218 41.5856H70.874V46.7331H76.2218V41.5856Z",
    fill: "#B1E1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6397 36.0444H40.292V41.192H45.6397V36.0444Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6397 41.5856H40.292V46.7331H45.6397V41.5856Z",
    fill: "#0383A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2393 39.9872H53.3613C53.1095 39.9872 52.9197 39.7579 52.9714 39.5114C53.1923 38.4368 54.1514 37.629 55.3003 37.629C56.4492 37.629 57.4083 38.4368 57.6292 39.5114C57.6809 39.7579 57.4912 39.9872 57.2393 39.9872Z",
    fill: "#B1E1F4"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8374_34257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 72,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8374_34257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 88,
    fill: "white",
    transform: "translate(-4 -12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareTransitionsAndHospitalCare);
export default __webpack_public_path__ + "static/media/CareTransitionsAndHospitalCare.e3be52934911b76f8a8c7e3d1c9eaadb.svg";
export { ForwardRef as ReactComponent };